package org.hs_soft.runmynesto.domain.usecase.options.cash_register_config

import org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.devices.create_new_department.CreateNewDepartmentModel
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.cash_register_config.CreateNewDepartmentReopisotry


class CreateNewDepartmentUseCase(
    private val repository: CreateNewDepartmentReopisotry
) {
    suspend operator fun invoke(
       name:String
    ): CreateNewDepartmentModel {
        return repository.createNewDepartment(
            name=name
        )
    }
}